// La encuesta del agente (`preguntar`) ocupa el lugar de la caja de texto en vez de mostrarse arriba
// de ella: con las dos a la vista había dos lugares para contestar lo mismo
// (ADR-2026-10-22-la-encuesta-reemplaza-la-caja-de-texto). Puro.

/** ¿Esta card es la encuesta? */
export const esEncuesta = (card: { kind: string } | null | undefined): boolean => card?.kind === 'preguntar';

/**
 * La encuesta que va en el lugar de la caja, o null si va la caja: no hay encuesta activa, o la
 * persona tocó "Prefiero escribirlo" en ÉSA (`escribirEn` es el id de la card).
 */
export function encuestaEnLaCaja<T extends { id: string; kind: string }>(
  activa: T | null | undefined,
  escribirEn: string | null,
): T | null {
  if (!activa || !esEncuesta(activa)) return null;
  return activa.id === escribirEn ? null : activa;
}
